$(document).ready(function () {
  if ($('.js-arrow-content').length) {
    $('.js-arrow-next').click(function () {
      $(this)
        .parents()
        .nextAll('.js-arrow-content')
        .animate({ scrollLeft: '+=200' }, 300);
    });
    $('.js-arrow-prev').click(function () {
      $(this)
        .parents()
        .nextAll('.js-arrow-content')
        .animate({ scrollLeft: '-=200' }, 300);
    });
  }
});
